import { render } from "./group_List.vue?vue&type=template&id=d20850e8"
import script from "./group_List.vue?vue&type=script&lang=js"
export * from "./group_List.vue?vue&type=script&lang=js"

import "./group_List.vue?vue&type=style&index=0&id=d20850e8&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__